import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M5 3a2 2 0 0 0-2 2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M19 3a2 2 0 0 1 2 2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 19a2 2 0 0 1-2 2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M5 21a2 2 0 0 1-2-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9 3h1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9 21h1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 3h1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 21h1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 9v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 9v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 14v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 14v1", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "BoxSelect";
const BoxSelect = memo(themed(Icon));
export {
  BoxSelect
};
//# sourceMappingURL=box-select.js.map
